<div class="accessibility-settings w-[373px]">
  <form [formGroup]="form">
    <div class="pt-5 px-5">
      <span class="app__form--attribute--title font-bold text-[20px] leading-4">Share with</span>
      <div class="app__centered-item justify-start h-12 px-2 mt-3" style="border-radius: 4px; margin: 15px 0px; background: #f3f2f1">
        <ngx-avatars size="24" src="{{ data?.profile_image }}" name="{{ data?.name | titlecase }}" [round]="true" initialsSize="2"></ngx-avatars>
        <span class="app__form--attribute--title font-semibold text-[12px] leading-[18px] text-[#18191C] ml-3">{{
          data?.name | capitalizeRomanNumerals | titlecase | truncateStrPipe : 22
        }}</span>
      </div>

      <div class="mt-[10px]">
        @if(data?.origin === 'contact' || data?.origin === 'password' && !this.data?.shareDetails){
        <span class="app__form--attribute--title font-normal text-[12px] leading-4">Permission Type</span>
        <mat-form-field
          appearance="fill"
          class="accessibility-form app__remove--subscript--wrapper w-full mt-2 custom-accesibility-select"
          [class]="'mb-3'"
        >
          <!-- <mat-label class="automtic-form-desing-lable">Permission Type</mat-label> -->
          <mat-select formControlName="permissionType" (selectionChange)="changePermissionType()">
            <mat-option value="owner">
              <div class="app__centered-item justify-start">Owner</div>
            </mat-option>
            <mat-option value="recipient">
              <div class="app__centered-item justify-start">Recipient</div>
            </mat-option>
          </mat-select>
        </mat-form-field>
        } @if(!isPermissionTypeOwner){
        <!-- <span class="app__form--attribute--title font-normal text-[12px] leading-4">Accessible</span> -->
        <mat-form-field
          appearance="fill"
          class="accessibility-form app__remove--subscript--wrapper w-full mt-2 custom-accesibility-select"
          [class]="!accessibilityTypeNow ? 'mb-3' : 'mb-[2px]'"
        >
          <mat-label class="automtic-form-desing-lable">Accessible</mat-label>
          <mat-select formControlName="accessibleTypes" (selectionChange)="changeAccessible()">
            @if (getAccessibilityType(); as accessibilityType) {
            <mat-select-trigger>
              <div class="app__centered-item justify-start">
                <span class="w-[7px] h-[7px] block rounded-[100px] mr-[5px]" [style.background]="accessibilityType.color"></span>
                {{ accessibilityType.name }}
                @if(accessibilityType.name === 'Later') {
                <i
                  class="text-[16px] ml-2 material-icons text-[#25508e] mt-1"
                  matTooltip="Making something accessible 'Later' means it will become accessible in the event that {{
                    data?.currentUsername
                  }} passes away."
                  >info</i
                >
                }
              </div>
            </mat-select-trigger>
            } @for (type of accessibleTypes; track type) {
            <mat-option [value]="type">
              <div class="app__centered-item justify-start">
                <span class="w-[7px] h-[7px] block rounded-[100px] mr-[5px]" [style.background]="type.color"></span>
                {{ type.name }}
                @if(type.name === 'Later') {
                <i
                  class="text-[16px] ml-2 material-icons text-[#25508e] mt-1"
                  matTooltip="Making something accessible 'Later' means it will become accessible in the event that {{
                    data?.currentUsername
                  }} passes away."
                  >info</i
                >
                }
              </div>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (!accessibilityTypeDistributor && !accessibilityTypeNow) {
        <span class="app__form--attribute--title font-normal text-[12px] leading-4 mt-[40px] pt-[15px]">Start Date</span>
        } @if (!accessibilityTypeFuture && !accessibilityTypeNow) {
        <mat-form-field
          appearance="fill"
          class="accessibility-form app__remove--subscript--wrapper w-full mt-2 custom-accessibility-date-slect"
          [style.display]="accessibilityTypeDistributor ? 'none' : ''"
        >
          <!-- <mat-label class="automtic-form-desing-lable">{{ accessibilityTypeDistributor ? 'Via Data Distributor' : 'Select Date' }}</mat-label> -->
          <input
            matInput
            [matDatepicker]="accessibleDate"
            (click)="accessibleDate.open()"
            formControlName="accessibleDate"
            [disabled]="!accessibilityTypeFuture"
          />
          @if (!accessibilityTypeDistributor) {
          <mat-datepicker-toggle matSuffix [for]="accessibleDate"></mat-datepicker-toggle>
          }
          <mat-datepicker #accessibleDate panelClass="accessibility-datepicker"></mat-datepicker>
        </mat-form-field>
        <!-- 
          <reusable-date-input
            [style.display]="accessibilityTypeDistributor ? 'none' : ''"
            style="width: 100% !important; display: block"
            [classStyle]="'accessibility-form app__remove--subscript--wrapper w-full mt-2'"
            [title]="accessibilityTypeDistributor ? 'Via Data Distributor' : 'Select Date'"
            [controlName]="'accessibleDate'"
            [value]="form.controls['accessibleDate'].value"
            (dateChangeEmitter)="handleDateChange($event)"
            (changeEmitter)="handleDateChange2($event)"
          >
          </reusable-date-input> -->

        } @else { @if (!accessibilityTypeNow) {
        <reusable-date-input
          style="width: 100% !important; display: block"
          [classStyle]="'accessibility-form app__remove--subscript--wrapper w-full mt-2 custom-accessibility-date-slect'"
          [title]="'Enter start date'"
          [labelClass]="'automtic-form-desing-lable'"
          [controlName]="'accessibleDate'"
          [value]="form.controls['accessibleDate'].value"
          (dateChangeEmitter)="handleDateChange($event, 'accessibleDate')"
          (changeEmitter)="handleDateChange2($event, 'accessibleDate')"
          [form]="form"
          [min]="minDate"
        >
        </reusable-date-input>
        } } }
      </div>
    </div>
    @if(!isPermissionTypeOwner && !accessibilityTypeDistributor){
    <div [class]="!accessibilityTypeNow ? 'mt-[4px] pl-1 pr-1' : 'pl-4 pr-2 d-flex flex-col'">
      <!--  Set end date -->
      <mat-checkbox
        #enddate
        type="checkbox"
        [checked]="viewMode == 'view' && data.shareDetails?.end_date && data.shareDetails?.end_date != '0000-00-00'"
        [disabled]="accessibilityTypeDistributor"
        [class.disabled]="accessibilityTypeDistributor"
        (change)="toggle($event)"
      >
        <span class="app__form--attribute--title text-[12px] font-normal leading-[17px]"> Set End Date </span>
      </mat-checkbox>

      @if (endDateSelected) {
      <div class="px-2 w-full">
        <reusable-date-input
          [ngClassStyle]="'accessibility-form'"
          [classStyle]="
            form.get('endDate').value != null && form.get('accessibleDate').value != null && form.get('endDate').value
              | dateCompare
                : (form.get('accessibleDate').value
                    ? ''
                    : 'accessibility-form app__remove--subscript--wrapper w-full custom-accessibility-date-slect')
          "
          [title]="'End Date'"
          [labelClass]="'automtic-form-desing-lable'"
          [controlName]="'endDate'"
          [value]="form.controls['endDate'].value"
          (dateChangeEmitter)="handleDateChange($event, 'endDate')"
          (changeEmitter)="handleDateChange2($event, 'endDate')"
          [min]="form?.get('accessibleDate')?.value ? form.get('accessibleDate').value : tomorrowsDate"
          [hasError]="
            form.get('endDate').value == null ||
            (form.get('endDate').value != null && form.get('endDate').value | dateCompare : form.get('accessibleDate').value)
          "
          [isRequired]="true"
          [error]="form.get('endDate').value ? 'End Date should be > Start Date' : 'Please enter end date'"
        >
        </reusable-date-input>
      </div>

      }

      <!-- Grant Edit Access -->
      <mat-checkbox
        type="checkbox"
        formControlName="editAccess"
        [disabled]="accessibilityTypeDistributor"
        [class.disabled]="accessibilityTypeDistributor"
      >
        <span class="app__form--attribute--title flex text-center items-center text-[12px] font-normal leading-4">
          Grant Edit Access
          <i
            class="material-icons"
            matTooltip="By selecting this, edit access will be given to the person you're sharing with on the date you've selected above."
            >info</i
          >
        </span>
      </mat-checkbox>

      <!-- Receive Notification -->
      <mat-checkbox
        type="checkbox"
        formControlName="receiveNotification"
        [disabled]="accessibilityTypeDistributor"
        [class.disabled]="accessibilityTypeDistributor"
      >
        <span class="app__form--attribute--title flex text-center items-center text-[12px] font-normal leading-4">
          Receive Notifications
          <i
            class="material-icons"
            matTooltip="By selecting this, you will be notified any time this is viewed or downloaded by the person you're sharing it with."
            >info</i
          >
        </span>
      </mat-checkbox>
    </div>
    }
    <div class="action">
      <button
        mat-button
        class="cancel-button"
        (click)="close()"
        style="border: 1.2px solid #25508e; background-color: #ffffff; width: 161px; height: 48px"
      >
        Cancel
      </button>
      <button mat-button class="add-button w-[161px] h-[48px]" [class.disable-button-continue]="form.invalid" (click)="confirmShareTypeClicked()">
        Save
      </button>
    </div>
  </form>
</div>
